import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Page from '../../../componentes/plantilla/Page';
import Card from '../../../componentes/contenedores/Card';
import { PlanillaServicio } from '../../../servicios/planillaServicio';
import { mostraAlerta, mostraAlertaOk } from '../../../componentes/alerts/sweetAlert';

const ConfiguracionLaboral = () => {
  const [configuraciones, setConfiguraciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [empleadoEditando, setEmpleadoEditando] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);

  const datosPage = {
    titulo: {
      titulo: 'Configuración Salarial y Modalidades Laborales',
      url: '/app/admin/planillas/configuracion',
      tituloUrl: 'Planillas',
      nombreUrl: 'Configuración Salarial',
    },
  };

  const cargarConfiguraciones = async () => {
    try {
      setCargando(true);
      const data = await PlanillaServicio.listarConfiguraciones();
      setConfiguraciones(data);
    } catch (err) {
      mostraAlerta('Error al cargar configuraciones de empleados', 'error');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarConfiguraciones();
  }, []);

  const abrirEdicion = (config) => {
    setEmpleadoEditando({ ...config });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setEmpleadoEditando(null);
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    if (!empleadoEditando) return;

    try {
      await PlanillaServicio.guardarConfiguracion({
        ...empleadoEditando,
        salarioBaseMensual: Number(empleadoEditando.salarioBaseMensual || 0),
        porcentajeComision: Number(empleadoEditando.porcentajeComision || 0),
      });
      mostraAlertaOk('Configuración salarial actualizada correctamente');
      cerrarModal();
      cargarConfiguraciones();
    } catch (err) {
      mostraAlerta('Error al guardar la configuración', 'error');
    }
  };

  const formatLempiras = (val) =>
    `L ${Number(val || 0).toLocaleString('es-HN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  return (
    <Page datos={datosPage}>
      {/* Botón Volver y Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Link to="/app/admin/planillas" className="btn btn-outline-secondary btn-sm">
          <i className="fas fa-arrow-left mr-1"></i> Volver a Planillas
        </Link>
        <span className="text-muted small">
          <i className="fas fa-info-circle mr-1"></i> Defina las modalidades de pago para el cálculo automático de nómina
        </span>
      </div>

      <Card
        titulo="Configuración de Salarios y Comisiones por Empleado"
        subtitulo="Asigne si el empleado percibe sueldo fijo, sueldo base + comisión o comisión pura sobre ventas."
      >
        {cargando ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="text-muted mt-2">Cargando nómina...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="thead-dark">
                <tr>
                  <th>Empleado</th>
                  <th>Cargo / Puesto</th>
                  <th>Modalidad de Contratación</th>
                  <th className="text-right">Sueldo Base Mensual</th>
                  <th className="text-center">% Comisión</th>
                  <th className="text-center">IHSS</th>
                  <th className="text-center">RAP</th>
                  <th className="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {configuraciones.map((cfg) => (
                  <tr key={cfg.empleadoId}>
                    <td>
                      <div className="font-weight-bold">{cfg.nombreEmpleado}</div>
                      <small className="text-muted">ID: {cfg.empleadoId}</small>
                    </td>
                    <td>{cfg.cargo}</td>
                    <td>
                      <span
                        className={`badge ${
                          cfg.modalidad === 'SUELDO_BASE'
                            ? 'badge-secondary'
                            : cfg.modalidad === 'BASE_MAS_COMISION'
                            ? 'badge-success'
                            : 'badge-warning'
                        }`}
                      >
                        {cfg.modalidad === 'SUELDO_BASE'
                          ? 'Sueldo Fijo'
                          : cfg.modalidad === 'BASE_MAS_COMISION'
                          ? 'Base + Comisión'
                          : 'Solo Comisión'}
                      </span>
                    </td>
                    <td className="text-right font-weight-bold">
                      {cfg.modalidad === 'SOLO_COMISION' ? (
                        <span className="text-muted">L 0.00 (Variable)</span>
                      ) : (
                        formatLempiras(cfg.salarioBaseMensual)
                      )}
                    </td>
                    <td className="text-center font-weight-bold">
                      {cfg.porcentajeComision > 0 ? (
                        <span className="text-success">{cfg.porcentajeComision}%</span>
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td className="text-center">
                      {cfg.aplicaIHSS ? (
                        <i className="fas fa-check text-success" title="Aplica Seguro Social"></i>
                      ) : (
                        <i className="fas fa-times text-muted" title="Exento"></i>
                      )}
                    </td>
                    <td className="text-center">
                      {cfg.aplicaRAP ? (
                        <i className="fas fa-check text-success" title="Aplica RAP"></i>
                      ) : (
                        <i className="fas fa-times text-muted" title="Exento"></i>
                      )}
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => abrirEdicion(cfg)}
                      >
                        <i className="fas fa-edit mr-1"></i> Editar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      {/* Modal de Edición de Configuración Salarial */}
      {modalAbierto && empleadoEditando && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(15, 23, 42, 0.6)' }}
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow border-0">
              <form onSubmit={handleGuardar}>
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title font-weight-bold">
                    <i className="fas fa-user-cog mr-2"></i> Configuración Laboral: {empleadoEditando.nombreEmpleado}
                  </h5>
                  <button type="button" className="close text-white" onClick={cerrarModal}>
                    <span>&times;</span>
                  </button>
                </div>

                <div className="modal-body p-4">
                  <div className="mb-3">
                    <label className="font-weight-bold">Modalidad de Compensación *</label>
                    <select
                      className="form-control"
                      value={empleadoEditando.modalidad}
                      onChange={(e) => {
                        const nuevaMod = e.target.value;
                        setEmpleadoEditando({
                          ...empleadoEditando,
                          modalidad: nuevaMod,
                          salarioBaseMensual: nuevaMod === 'SOLO_COMISION' ? 0 : empleadoEditando.salarioBaseMensual,
                          porcentajeComision: nuevaMod === 'SUELDO_BASE' ? 0 : empleadoEditando.porcentajeComision,
                          aplicaIHSS: nuevaMod !== 'SOLO_COMISION',
                          aplicaRAP: nuevaMod !== 'SOLO_COMISION',
                        });
                      }}
                    >
                      <option value="SUELDO_BASE">Sueldo Base Fijo (Sin comisiones)</option>
                      <option value="BASE_MAS_COMISION">Sueldo Base + Comisión (% sobre ventas)</option>
                      <option value="SOLO_COMISION">Solo Comisión (100% variable sobre ventas)</option>
                    </select>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold">Salario Base Mensual (L.) *</label>
                      <input
                        type="number"
                        min="0"
                        step="100"
                        disabled={empleadoEditando.modalidad === 'SOLO_COMISION'}
                        className="form-control"
                        value={empleadoEditando.salarioBaseMensual}
                        onChange={(e) =>
                          setEmpleadoEditando({
                            ...empleadoEditando,
                            salarioBaseMensual: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold">Porcentaje de Comisión (%)</label>
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.5"
                        disabled={empleadoEditando.modalidad === 'SUELDO_BASE'}
                        className="form-control font-weight-bold text-success"
                        value={empleadoEditando.porcentajeComision}
                        onChange={(e) =>
                          setEmpleadoEditando({
                            ...empleadoEditando,
                            porcentajeComision: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="card p-3 border mb-3">
                    <span className="font-weight-bold small text-muted text-uppercase mb-2 d-block">
                      Deducciones Legales Hondureñas
                    </span>
                    <div className="custom-control custom-checkbox mb-2">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="chkIHSS"
                        checked={empleadoEditando.aplicaIHSS}
                        onChange={(e) =>
                          setEmpleadoEditando({
                            ...empleadoEditando,
                            aplicaIHSS: e.target.checked,
                          })
                        }
                      />
                      <label className="custom-control-label font-weight-normal" htmlFor="chkIHSS">
                        Aplicar retención del <strong>IHSS</strong> (Seguro Social, 3.5% con tope legal)
                      </label>
                    </div>

                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="chkRAP"
                        checked={empleadoEditando.aplicaRAP}
                        onChange={(e) =>
                          setEmpleadoEditando({
                            ...empleadoEditando,
                            aplicaRAP: e.target.checked,
                          })
                        }
                      />
                      <label className="custom-control-label font-weight-normal" htmlFor="chkRAP">
                        Aplicar retención del <strong>RAP</strong> (Régimen de Aportaciones Privadas, 1.5%)
                      </label>
                    </div>
                  </div>

                  <div className="mb-2">
                    <label className="font-weight-bold small">Observaciones o Notas</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Notas adicionales (opcional)..."
                      value={empleadoEditando.observaciones || ''}
                      onChange={(e) =>
                        setEmpleadoEditando({
                          ...empleadoEditando,
                          observaciones: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary font-weight-bold">
                    <i className="fas fa-save mr-1"></i> Guardar Cambios
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Page>
  );
};

export default ConfiguracionLaboral;
